import { Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { Audit, AuditFilter, AuditsFiltersMeta } from '../../models/audit';
import { iterableAuditClassNameLabels, iterableAuditTypeLabels } from '../../utils';

@Component({
  selector: 'app-audits-filters',
  styleUrls: ['./audits-filters.component.scss'],
  templateUrl: './audits-filters.component.html',
})
export class AuditsFiltersComponent extends BaseFiltersComponent<Audit, FilterFieldsOptions<AuditFilter>> {

  readonly iterableAuditClassNameLabels = iterableAuditClassNameLabels;
  readonly iterableAuditTypeLabels = iterableAuditTypeLabels;

  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, AuditsFiltersMeta);
  }
}
